(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-simple"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.getElementById('cm-gallery-{{ section.id }}');
    if(!root) return;
    var dlg = root.querySelector('.cm-gallery__dialog');
    if(!dlg) return;
    var img = root.querySelector('.cm-gallery__dlg-img');
    var closeBtn = root.querySelector('.cm-gallery__close');

    root.addEventListener('click', function(e){
      var link = e.target.closest('[data-lightbox]');
      if(!link) return;
      e.preventDefault();
      img.src = link.getAttribute('href');
      img.alt = link.querySelector('img')?.alt || '';
      if(typeof dlg.showModal === 'function'){ dlg.showModal(); }
      else { window.open(img.src, '_blank'); } // 旧浏览器兜底
    });

    if(closeBtn){ closeBtn.addEventListener('click', function(){ dlg.close(); }); }
    if(dlg){ dlg.addEventListener('click', function(e){ if(e.target === dlg) dlg.close(); }); }
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && dlg.open) dlg.close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price"] && !Shopify.designMode) return;
  try {
    
  // 预留：如需动态行为可在此扩展

  } catch(e) { console.error(e); }
})();
})();
